
$(document).ready(function () {
    $('.our-works-item').slick({
        slidesToShow: 3,
        arrows: true,
        centerMode: true,
        variableWidth: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),

    });
});
$('.left').on('click', function () {
    const video = document.getElementById('about-us__video');

    if (video.paused) {
        video.play();
    } else {
        video.pause();
    }
});

